import { FC } from "react";
import { CooldownButton, CooldownButtonProps } from "./CooldownButton"

export type GlyphButtonProps = {

} & Omit<CooldownButtonProps, 'width' | 'height' | 'spell' | 'hero'>;

export const GlyphButton: FC<GlyphButtonProps> = ({ ...rest }) => {
    return (<CooldownButton
        hero={{ icon: '', name: '', spells: [] }}
        spell={{
            icon: './glyph.png',
            name: 'glyph',
            maxCooldown: [300]
        }}
        width={128} height={128} {...rest} />);
}